import { render, staticRenderFns } from "./handwenju.vue?vue&type=template&id=5d6e0a97"
import script from "./handwenju.vue?vue&type=script&lang=js"
export * from "./handwenju.vue?vue&type=script&lang=js"
import style0 from "./handwenju.vue?vue&type=style&index=0&id=5d6e0a97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports